import styled from '@emotion/styled'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import NotFoundIcon from 'assets/images/404.png'
import { RouteName } from 'constants/constants'
import { useNavigate } from 'react-router-dom'

const CustomImg = styled.img`
  max-width: 500px;
  max-height: 400px;
  /* width: 50vw; */
  height: 35vh;
  min-height: 200px;
`

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '650px',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CustomImg src={NotFoundIcon} alt="NotFoundIcon" />
      <Typography variant="h4" mb="12px">
        Whoops!
      </Typography>
      <Typography variant="body1" mb="32px">
        We can’t seem to find the page you’re looking for.
      </Typography>
      <Button variant="contained" onClick={() => navigate(RouteName.default)}>
        Back to the app
      </Button>
    </Box>
  )
}

export default NotFound
